export default __webpack_public_path__ + "speech-bubbles-comment-option.png";